/** @format */

export function updateUrlWithParams(base: string) {
  const params = new URLSearchParams(window.location.search);
  const paramsObj: { [key: string]: string } = {};
  params.forEach((value, key) => {
    paramsObj[key] = value;
  });

  const url = new URL(base);
  const searchParams = new URLSearchParams(url.search);

  Object.entries(paramsObj).forEach(([key, value]) => {
    searchParams.set(key, value);
  });

  url.search = searchParams.toString();
  return url.toString();
}
